import { render, staticRenderFns } from "./PurchasesHome.vue?vue&type=template&id=6862f09c&scoped=true&"
import script from "./PurchasesHome.vue?vue&type=script&lang=js&"
export * from "./PurchasesHome.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesHome.vue?vue&type=style&index=0&id=6862f09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6862f09c",
  null
  
)

export default component.exports